import type { IndicatorReading } from '@/lib/assessment/namatAssessment';

type T = (key: string) => string;

/** A health indicator's unit in the reader's language (cm -> سم, years -> سنة, #56); units without a translation show as stored. */
export function indicatorUnit(reading: Pick<IndicatorReading, 'unit'>, t: T): string {
  const key = `common.health.units.${reading.unit}`;
  const label = t(key);
  return label && label !== key ? label : reading.unit;
}
